package com.eladfinish.bible.contest.screens.misc

import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt

data object MiscState : StateKt

sealed interface MiscAction : ActionKt {
    data object SeminarClicked : MiscAction
}

sealed interface MiscEffect : EffectKt {
    data object NavigateToSeminar : MiscEffect
    data class ShowMessage(val text: String) : MiscEffect
}
